import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import styles from './PortfolioSection.module.scss'
import { Link } from 'react-router'
import Masonry from 'react-masonry-component'
import PortfolioCard from './PortfolioCard'
import cn from 'classnames'

class PortfolioSection extends React.Component {
  
  static propTypes () {
    return {
      works: React.PropTypes.array,
      workCategories: React.PropTypes.array
    }
  }

  constructor () {
    super();
    this.state = {
      selectedCategory: 'all'
    };
  }

  categorySelected (workCategory) {
    console.log('categorySelected');
    console.log(workCategory);
    this.setState({ selectedCategory: workCategory.value });
  }

  render () {
    
    const masonryOptions = {
      transitionDuration: 0,
      fitWidth: true,
      gutter: 30
    };

    let works = this.props.works || [];
    let workCategories = this.props.workCategories || [];
    let allCategories = this.state.selectedCategory === 'all' || false;

    let filteredWorks = allCategories ? works : _.filter(works, (w) => (
      (w.categories || []).indexOf(this.state.selectedCategory) >= 0
    ));

    console.log(this.props);

    return (
      <div>
        {/* Hide Tags
        <div className={styles.workCategories}>
          <button className={cn(styles.workCategory, 'hvr-shrink')} onClick={() => {this.categorySelected({ value: 'all' })}}>All</button>
          {workCategories.map(wc => (
            <button className={cn(styles.workCategory, 'hvr-shrink')} key={wc.name} onClick={() => {this.categorySelected(wc)}}>{wc.name}</button>
          ))}
        </div>
        */}

        <div className="section-works">
          <Masonry
            className={'masonry-portfolio'} // default ''
            elementType={'ul'} // default 'div'
            options={masonryOptions} // default {}
            disableImagesLoaded={false} // default false
            updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
          >
            
            {filteredWorks.map(w => (<PortfolioCard data={w} key={w.name}/>))}
          </Masonry>
        </div>
      </div>
    )
  }
}

export default PortfolioSection



/** WEBPACK FOOTER **
 ** ../components/PortfolioSection.js
 **/